(function () {
  'use strict';

  function openModal(modal) {
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = modal.querySelector('[data-coa-close]');
    if (close) close.focus();
  }
  function closeModal(modal) {
    modal.hidden = true;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function parseMap() {
    var el = document.querySelector('[data-coa-map]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function currentVariantId() {
    try {
      var v = new URL(window.location.href).searchParams.get('variant');
      if (v) return String(v);
    } catch (e) {}
    var input = document.querySelector(
      'form[action*="/cart/add"] [name="id"], product-form [name="id"], [name="id"]'
    );
    if (input && input.value) return String(input.value);
    return null;
  }

  function labelEl(trigger) {
    return trigger.querySelector('[data-coa-trigger-label]') || trigger.querySelector('span');
  }

  // Update every CoA trigger + its modal to the certificate for the selected variant.
  function applyCoa(map) {
    var root = document.querySelector('[data-coa-root]');
    var hasMap = map && Object.keys(map).length > 0;
    // Nothing to drive a swap from — leave the server-rendered markup untouched.
    if (!hasMap && !root) return;

    var vid = currentVariantId();
    var entry = (vid && map && map[vid]) ? map[vid] : null;
    var url = entry && entry.url ? entry.url
      : (root ? (root.getAttribute('data-coa-default-url') || '') : '');
    var batch = entry && (entry.batch || entry.batch === '') ? entry.batch
      : (root ? (root.getAttribute('data-coa-default-batch') || '') : '');

    document.querySelectorAll('[data-coa-trigger]').forEach(function (trigger) {
      if (!url) { trigger.hidden = true; return; }
      trigger.hidden = false;
      var L = labelEl(trigger);
      if (L) L.textContent = 'View Certificate of Analysis' + (batch ? ' · Batch ' + batch : '');
      var modal = document.getElementById(trigger.getAttribute('aria-controls'));
      if (modal) {
        var iframe = modal.querySelector('[data-coa-iframe]');
        var openLink = modal.querySelector('[data-coa-openlink]');
        var batchSpan = modal.querySelector('[data-coa-modal-batch]');
        if (iframe && iframe.getAttribute('src') !== url) iframe.setAttribute('src', url);
        if (openLink) openLink.setAttribute('href', url);
        if (batchSpan) batchSpan.textContent = batch ? ' · Batch ' + batch : '';
      }
    });
  }

  // Wire EVERY CoA trigger on the page (theme-agnostic — the trigger may live in
  // any section, e.g. the Trust section). This restores the global open behaviour.
  function wireAll() {
    document.querySelectorAll('[data-coa-trigger]').forEach(function (trigger) {
      if (trigger.dataset.coaWired === '1') return;
      var modal = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!modal) return;
      trigger.dataset.coaWired = '1';
      trigger.addEventListener('click', function () { openModal(modal); });
      modal.querySelectorAll('[data-coa-close]').forEach(function (c) {
        c.addEventListener('click', function () { closeModal(modal); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
      });
    });
  }

  function init() {
    if (!document.querySelector('[data-coa-trigger]')) return;
    var map = parseMap();
    wireAll();
    applyCoa(map);

    if (document.documentElement.dataset.coaWatch === '1') return;
    document.documentElement.dataset.coaWatch = '1';

    document.addEventListener('change', function () {
      setTimeout(function () { applyCoa(map); }, 60);
    });
    window.addEventListener('popstate', function () { applyCoa(map); });
    var last = currentVariantId();
    setInterval(function () {
      var now = currentVariantId();
      if (now !== last) { last = now; applyCoa(map); }
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
